const COMMENT = '#comment-';
const SUGGESTION = '#suggestion-';

const { userAgent } = window.navigator;
const SMOOTH = !(userAgent.includes('Chrome') || userAgent.includes('Firefox')); // smooth behaviour not  working properly for firefox and chrome

const scrollToId = (id) => {
    const hashElement = document.getElementById(id);
    if (hashElement) {
        hashElement.scrollIntoView({ behavior: 'smooth' });
    }
};

const scrollToIdIfNotInView = (id) => {
    const hashElement = document.getElementById(id);
    if (hashElement) {
        const rect = hashElement.getBoundingClientRect();
        if (rect.top < 0 || rect.bottom > window.innerHeight) {
            hashElement.scrollIntoView({ behavior: 'smooth' });
        }
    }
};

const scrollToHash = (smooth = false) => {
    setTimeout(() => {
        const { hash } = window.location;
        if (hash && smooth) {
            const id = hash.slice(1);
            scrollToId(id);
        } else if (hash) {
            window.location.hash = '';
            window.location.hash = hash;
        }
    }, 1);
};

const scrollToComment = () => {
    const { hash } = window.location;
    if (!hash || !hash.startsWith(COMMENT)) return;

    scrollToHash(SMOOTH);
};

const scrollToSuggestion = () => {
    const { hash } = window.location;
    if (!hash || !hash.startsWith(SUGGESTION)) return;

    scrollToHash(SMOOTH);
};

const scrollToHeader = () => {
    const { hash } = window.location;
    if (!hash || hash.startsWith(COMMENT) || hash.startsWith(SUGGESTION)) return;

    scrollToHash(SMOOTH);
};

export {
    scrollToComment,
    scrollToHash,
    scrollToHeader,
    scrollToId,
    scrollToSuggestion,
    scrollToIdIfNotInView,
};
